export const TreatmentNames = {
  RESULTS_BUNDLE_MAIN_ACTION: 'results_bundle_main_action',
  FMB_ONE_PAGE_VIEW: 'fmb_one_page_view',
  FMB_CHANGE_FLOW: 'fmb_change_flow',
  BLACK_FRIDAY_BANNER_POSITION: 'black_friday_banner_position',
};

export default TreatmentNames;
